var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_2200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 0H11.136V2.54391H12.8638V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30396 2.9761V15.6961H21.6961V2.9761H2.30396ZM20.304 14.2561H3.69614V4.3186H20.304V14.2561Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24774 8.9278H5.18384V13.0078H7.24774V8.9278Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74384 7.44H7.67993V13.0078H9.74384V7.44Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2878 6H10.2239V13.0078H12.2878V6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 11.28H14.2561V11.76H18.8639V11.28Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8961 12.5278H14.2561V13.0078H16.8961V12.5278Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 10.08H14.2561V10.56H18.8639V10.08Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 8.83218H14.2561V9.31218H18.8639V8.83218Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8638 6H16.896V7.96781H18.8638V6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2239 6H14.2561V7.96781H16.2239V6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7522 24H6.5761L8.78392 16.08H6.96001L4.7522 24Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2161 16.08L17.4239 24H19.2478L17.04 16.08H15.2161Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_2200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasel);
export default __webpack_public_path__ + "static/media/easel.7d00b959cca61d6900be88312ffa330a.svg";
export { ForwardRef as ReactComponent };